import { msg } from '@lingui/core/macro';
import { TeamViewTab } from 'modules/teams/domain/enums/team-view-tab';
import type { MessageDescriptor } from 'shared/i18n';

/**
 * Подписи и порядок вкладок карточки команды.
 *
 * Подписи — дескрипторы, а не строки: переводятся в рендере (`t(tab.label)`), иначе строка,
 * посчитанная на импорте модуля, не пережила бы смену языка. Hash-и — в
 * `domain/enums/team-view-tab.ts`, они часть роута.
 */
export const TEAM_VIEW_TABS: { hash: TeamViewTab; label: MessageDescriptor }[] = [
  { hash: TeamViewTab.COMMON, label: msg`Основные данные` },
  { hash: TeamViewTab.PLAYERS, label: msg`Игроки` },
  // Вкладка «Администраторы» (hash `admins`) была закомментирована до этой задачи.
  { hash: TeamViewTab.PARTICIPANTS, label: msg`Участники` },
  { hash: TeamViewTab.WAITING_LIST, label: msg`Лист ожидания` },
  { hash: TeamViewTab.KITS, label: msg`Форма команды` },
];
